var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#050505;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,1.1L2.5,6.5v10.9l9.5,5.5l9.5-5.5V6.5L12,1.1z M12,2.2l8,4.6l-2.8,1.6L9.2,3.8L12,2.2z M7.3,5L7.3,5 l7.9,4.6L12,11.4L4,6.8L7.3,5z M3.5,7.7l8,4.6v9.2l-8-4.6V7.7z M20.5,16.9l-8,4.6v-9.2l3.2-1.8v3.5l2-1.2V9.3l2.8-1.6V16.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProduct);
export default __webpack_public_path__ + "static/media/icon-product.4dd8c4edcf521bad74b8611a9b13eae0.svg";
export { ForwardRef as ReactComponent };